__webpack_require__.p = "/@resources/isusys-chatbot-wrapper/";